"use client"
import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import "@/app/style/header.scss";
import { switchLanguage, openTarget, adobeData } from '@/app/utils/Common';
import { GET_HEADER } from "@/app/utils/request/query";
import { getHeader } from "@/app/utils/request/requestList";
import { LANGTYPE_CT, LANGTYPE_EN, LANGUAGE, str2LangCode, useLanguage } from '@/app/utils/LanguageContext';
import { redirectPage, theme, getLoginInfo } from "@/app/utils/Common";
import { useMediaQuery } from "@mui/material";
import cookie from 'react-cookies';
import "@/app/style/comm.scss";
import { useMyContext } from '@/app/utils/MyContext';

const ALLOWED_SEARCH_ORIGINS = [
  "https://search.hkjc.com"
];

const Header = () => {
  const { state: myContextState } = useMyContext();
  const { state: lang } = useLanguage();
  const { t: dict } = lang;
  const [headerData, setHeader] = useState<any>();
  const [salut, setSalut] = useState<string>("");
  const [searchTxt, setSearchTxt] = useState<string>("");
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")) ?? false;
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [showDisplayName, setShowDisplayName] = useState("");

  useEffect(() => {
    getHeader(
      {
        path: "/sitecore/content/Sites/JCRW/SiteConfiguration/Header",
        language: lang.langCode,
      },
      GET_HEADER,
      "cms"
    )
      .then((res: any) => {
        normalizeMainMenu(res);
      })
      .catch((e: any) => {
        console.log(e);
      });
  }, []);

  const normalizeMainMenu = (res: any) => {
    const data = res?.item;
    if (data !== null && data !== undefined) {
      setHeader(data);
    }
  }

  const getAllowedSearchPageUrl = () => {
    const searchPage =
      lang.langType === LANGTYPE_EN
        ? window.globalConfig?.LINKED_PAGES?.SEARCHPAGEENG
        : window.globalConfig?.LINKED_PAGES?.SEARCHPAGECHI;

    if (!searchPage) {
      return null;
    } 
       
    try { 
      const url = new URL(searchPage?.startsWith('//') ?  "https:" + searchPage : searchPage);

      if (!ALLOWED_SEARCH_ORIGINS.includes(url.origin)) {
        return null;
      }

      return url;
    } catch(e) {
      console.log("search error", e)
      return null;
    }
  };

  const submitSearch = (e?: any) => {
    if (e && e.key !== "Enter") return;

    // keep original behavior: trim leading & trailing spaces
    const keyword = searchTxt.trim(); 

    if (!keyword) {
      if (lang.langType === LANGTYPE_EN)
        alert("Please input a search query");
      if (lang.langType === LANGTYPE_CT)
        alert("請輸入搜尋字串");
      return;
    }  
    
    const searchPageUrl = getAllowedSearchPageUrl();
    if (!searchPageUrl) {
      return;
    }

    searchPageUrl.searchParams.set("g", "all");
    //searchPageUrl.searchParams.set("k", btoa(keyword)); 

    searchPageUrl.search = `${searchPageUrl.searchParams.toString()}&k=${toLegacyBase64QueryValue(keyword)}`;
  
    console.log("submitSearch", searchPageUrl )
    window.location.assign(searchPageUrl.toString());
  } 

  function toLegacyBase64QueryValue(value: string) {
    const encodedValue = btoa(encodeURIComponent(value));
  
    const isValidBase64 = /^[A-Za-z0-9+/]+={0,2}$/.test(encodedValue);

    if (!isValidBase64) {
      throw new Error("Invalid encoded query value");
    }
  
    return encodeURIComponent(encodedValue).replace(/%3D/g, "=");
  }
 
  useEffect(() => {  

    if(!isMobile)
      getLoginStatus()
  
  }, [isMobile])

  let count = 0;
  const getLoginStatus = () => {
    const isUserProfileLoaded = localStorage.getItem("IsUserProfileLoaded");
    console.log("getLoginInfo getLoginStatus isUserProfileLoaded", isUserProfileLoaded)
    if(count <= 10 && (isUserProfileLoaded == "false" || !isUserProfileLoaded)) {
      console.log("getLoginInfo getLoginStatus count", count) 
        setTimeout(() => {
          count++; 
          console.log("getLoginInfo getLoginStatus no")
          return getLoginStatus()
        }, 1000);  
    }else if(isUserProfileLoaded || count > 10 || WCIPCookie.isLoggedIn()){
      console.log("getLoginInfo getLoginStatus end")
      refreshGlobalLoginControl();
    }  
  };

  const refreshGlobalLoginControl = () => {
    const custProIn = cookie.load("custProIn");
    const {isLogin, displayName} = getLoginInfo(custProIn, lang.langType);
    setIsLogin(isLogin);
    setShowDisplayName(displayName);
    console.log("getLoginInfo", isLogin, displayName, window.WCIPCookie?.isLoggedIn())
  };
  
  const waTracker = (name: string) => {
    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      eventId: name,
    });
  }

  return (
    <div id="header">
      <Grid spacing={0} className="commBContent" container sx={{ maxWidth: "1808px", margin: "0 auto", padding: isMobile ? "" : "0 16px" }}>
        <Grid item lg={3}>
          {lang.langType === LANGTYPE_EN ? (<a id="logo" className="logo_en" href={headerData?.LeftLink?.value} target={openTarget(headerData?.LeftLinkNewWindow?.value)}>{headerData?.LeftImage?.value ? (<img src={headerData?.LeftImage?.src} alt={headerData?.LeftImage?.alt} id="imgMainLogo" />) : (<img src={`${myContextState.assetPrefix}/commonImg/logo_hkjc_e.png`} alt="The Hong Kong Jockey Club" id="imgMainLogo" />)}</a>) : (<a id="logo" className="logo_ch" href={headerData?.LeftLink?.value} target={openTarget(headerData?.LeftLinkNewWindow?.value)}>{headerData?.LeftImage?.value ? (<img src={headerData?.LeftImage?.src} alt={headerData?.LeftImage?.alt} id="imgMainLogo" />) : (<img src={`${myContextState.assetPrefix}/commonImg/logo_hkjc_c.png`} alt="香港賽馬會" id="imgMainLogo" />)}</a>)}
        </Grid>
        <Grid item lg={9} sx={{ display: { xs: 'none', lg: 'block' } }}>
          <div id="header_nav" className="nav">
            <div id="topNav">
              <div>
                <input name="searchkey" id="searchkey" type="hidden" />
                {
                  Object.keys(LANGUAGE).map((key: string, idx: any) => {
                    const code = str2LangCode(key)
                    if (lang.langCode === code) return
                    const homepage = lang.langType === LANGTYPE_EN ? window.globalConfig?.LINKED_PAGES?.HOMEPAGEENG : window.globalConfig?.LINKED_PAGES?.HOMEPAGECHI
                    return (
                      <span key={idx}>
                        <a href={homepage}>{dict("home")}</a><a onClick={() => switchLanguage(code)} className="lang">{LANGUAGE[code].display}</a>
                      </span>
                    )
                  })
                }
                <input maxLength={166} title="" placeholder={dict("search")} type="text" name="" id="searchtxt" onChange={(e) => setSearchTxt(e.target.value)} onKeyUp={(e) => submitSearch(e)} />
                <input className="iconToggle" type="image" name="" id="searchimg" src={`${myContextState.assetPrefix}/commonImg/icon_toggle.gif`} alt={dict("search")} onClick={() => submitSearch()} />
              </div>
              <div id="globalLoginControl">
                <div className="beforelogin" style={{ display: isLogin ? "none" : ""  }}><a className="login" href="javascript:;" onClick={(e) => redirectPage(e, 'login', lang.langType)}>{dict("login")}</a> / <a href="javascript:;" onClick={(e) => redirectPage(e, 'register', lang.langType)}>{dict("register")}</a><a href="javascript:;" onClick={(e) => redirectPage(e, 'help', lang.langType)} className="faq">{dict("faq")}</a></div>
                <div className="afterlogin" style={{ display: isLogin ? '' : "none"}}><div className="hkjc_login_message">
                  <span className="hkjc_greeting_name">{dict("hi")}{showDisplayName}</span><a className="logout" href="javascript:;" onClick={(e) => redirectPage(e, 'logout', lang.langType)}>{dict("logout")}</a> / </div><a href="javascript:;" onClick={(e) => redirectPage(e, 'preference', lang.langType)}>{dict("preference")}</a><a href="javascript:;" onClick={(e) => redirectPage(e, 'help', lang.langType)} className="faq">{dict("faq")}</a></div>
              </div>
              {/* <div id="ssoDiv"></div> */}
            </div>
            <div id="ewinContainer">
              <a className="ewin" onClick={(e) => waTracker('header_ewin_home')} href={headerData?.RightLink?.value} target={openTarget(headerData?.RightLinkNewWindow?.value)}><img src={headerData?.RightImage?.src ? headerData?.RightImage?.src : `${myContextState.assetPrefix}/commonImg/icon_ewin.png`} style={{ border: 0, width: 39, height: 40 }} alt={headerData?.RightImage?.alt} id="imgSubLogo" /></a>
              <a onClick={(e) => waTracker('header_ewin_racing')} href={headerData?.HRRedirectionLink?.value} target={openTarget(headerData?.HRRedirectionNewWindow?.value)} id="lblHR">{headerData?.HRLabel?.value}</a>
              <a onClick={(e) => waTracker('header_ewin_football')} href={headerData?.FBRedirectionLink?.value} target={openTarget(headerData?.FBRedirectionNewWindow?.value)} id="lblFB">{headerData?.FBLabel?.value}</a>
              <a onClick={(e) => { waTracker('header_ewin_marksix') }} href={headerData?.M6RedirectionLink?.value} target={openTarget(headerData?.M6RedirectionNewWindow?.value)} id="lblM6">{headerData?.M6Label?.value}</a>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}


export default Header